import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/Images/logo.png'

const Navbar = () => {
    return (
        <div className="sticky top-0 ">
            <div className="navbar  lg:px-32 py-3">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow  rounded-box w-52">
                            <li><Link>Home</Link></li>
                            <li><Link>About</Link></li>
                            <li><Link to='/contact'>Contact Us</Link></li>
                        </ul>
                    </div>

                    <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
                        <div className="w-fit rounded-full">
                            <img src={logo} alt='' />
                        </div>
                    </label>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0">
                        <li><Link to='/'>Home</Link></li>
                        <li><Link>About</Link></li>
                        <li><Link to='/contact'>Contact Us</Link></li>
                    </ul>
                </div>
                <div className="navbar-end">
                    <a target='_blank' href='https://calendly.com/d/gtt-5wm-89p/web-bee-meeting' className="btn">Quick Meeting</a>
                </div>
            </div>
        </div>
    );
};

export default Navbar;